import type { FC } from "react";
import React from "react";

import cn from "classnames";

import { IndicatorCounter } from "../../../../Indicator";

import type {
    PickOfUnion,
    PropsWithCustomColorsStylesNever,
} from "../../../../../types/react";
import type { IndicatorCounterProps } from "../../../../Indicator";

import buttonClasses from "../../Button.styl";

const BUTTON_INDICATOR_COUNTER_TEST_ID = "button-indicator-counter-test-id";

type ButtonIndicatorCounterProps = PickOfUnion<
    IndicatorCounterProps,
    "quantity"
> &
    PropsWithCustomColorsStylesNever;

export const ButtonIndicatorCounter: FC<ButtonIndicatorCounterProps> = (
    props,
): JSX.Element => {
    const { customColorsStyles, ...restProps } = props;

    return (
        <IndicatorCounter
            {...(restProps as IndicatorCounterProps)}
            customColorsStyles={cn(
                buttonClasses["indicator-counter"],
                customColorsStyles,
            )}
            view="custom"
            data-tsid={BUTTON_INDICATOR_COUNTER_TEST_ID}
        />
    );
};

ButtonIndicatorCounter.displayName = "Button.IndicatorCounter";

export default ButtonIndicatorCounter;
